module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-results"
  }, [_c('small-text', {
    staticClass: "search-results__count"
  }, [_vm._v(_vm._s(_vm.count) + " Results")]), _vm._v(" "), _c('scroll-panel', [_c('div', {
    staticClass: "search-results__list"
  }, _vm._l((_vm.searchResultsFormatted), function(results) {
    return _c('div', {
      staticClass: "search-results__result-set"
    }, [_c('list', {
      key: results.name,
      attrs: {
        "locked": _vm.locked,
        "list-group": results,
        "scrollable": false,
        "selectedValues": _vm.selectedValues,
        "advertiser": _vm.advertiser
      },
      on: {
        "onSelect": _vm.itemSelectedHandler
      }
    }), _vm._v(" "), (_vm.hasNoResults(results)) ? _c('small-text', {
      staticClass: "search-results__no-results",
      attrs: {
        "light": true
      }
    }, [_vm._v("No Results")]) : _vm._e()], 1)
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e5d7c11"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/workbench/attributePanel/components/SearchResults.vue
// module id = 1886
// module chunks = 0